import { render } from "./GaAuthTable.vue?vue&type=template&id=6e897e1d"
import script from "./GaAuthTable.vue?vue&type=script&lang=js"
export * from "./GaAuthTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__